let typeFormUtils = {
    isInputEl(type) {
        if (type === "ro" || type === "input") {
            return true;
        }
        return false;
    },
    isNumber(type) {
        if (type === "number") {
            return true;
        }
        return false;
    },
    isDateEl(type) {
        if (type === "date10" || type === "date8") {
            return true;
        }
        return false;
    },
    isDataDrop(type) {
        if (type === "sysCoding_ro") {
            return true;
        }
        return false;
    },
    isTreeDrop(type) {
        if (type === "treeDrop") {
            return true;
        }
        return false;
    },
    isStaticDrop(type) {
        if (type === "staticDrop" || type === "sysCoding_ro") {
            return true;
        }
        return false;
    },
    isColorSel(type) {
        if (type === "colorSel") {
            return true;
        }
        return false;
    },
    isMultipleDrop(type) {
        if (type === "multipleDrop") {
            return true;
        }
        return false;
    },
    isPageDropEl(type) {
        if (type === "pageDrop") {
            return true;
        }
        return false;
    },
    isWinObjEl(type) {
        if (type === "win") {
            return true;
        }
        return false;
    },
    isBooleanEl(type) {
        if (type === "boolean") {
            return true;
        }
        return false;
    },
    isTextArea(type) {
        if (type === "textArea") {
            return true;
        }
        return false;
    },
    isAclEl(type) {
        if (type === "aclWin") {
            return true;
        }
        return false;
    },
    isSlotEl(type) {
        if (type === "slot") {
            return true;
        }
        return false;
    },
    getSlotHtml({fieldId}) {
        return `<div class="row slotEl" fieldId="${fieldId}">&nbsp;</div>`;
    },
    isSwitchEl(type) {
        if (type === "switch"||type === "switch_ed") {
            return true;
        }
        return false;
    },
    isHiddenEl(type) {
        if (type === "hidden") {
            return true;
        }
        return false;
    },
    isRadioBox(type) {
        if (type === "radioBox") {
            return true;
        }
        return false;
    },
    isGridDrop(type) {
        if (type === "gridDrop") {
            return true;
        }
        return false;
    },
    isWinDrop(type) {
        if (type === "winDrop") {
            return true;
        }
        return false;
    },
    isLabel(type) {
        if (type === "label") {
            return true;
        }
        return false;
    }
};

export default typeFormUtils;



// WEBPACK FOOTER //
// ./goingsrc/common/typeFormUtils.js